import {
  BACKUP_BROADCAST_CHANNEL,
  type ChapterBackupBroadcastMessage,
  type ChapterBackupRecord,
} from './types'

type BackupListener = (message: ChapterBackupBroadcastMessage) => void

let channel: BroadcastChannel | null = null
const listeners = new Set<BackupListener>()

function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null
  if (!channel) {
    channel = new BroadcastChannel(BACKUP_BROADCAST_CHANNEL)
    channel.onmessage = (event: MessageEvent<ChapterBackupBroadcastMessage>) => {
      const message = event.data
      if (!message || typeof message !== 'object' || !('type' in message)) return
      listeners.forEach((listener) => listener(message))
    }
  }
  return channel
}

export function publishChapterBackupPut(
  projectId: string,
  chapterId: string,
  backup: ChapterBackupRecord,
): void {
  const ch = getChannel()
  if (!ch) return
  const message: ChapterBackupBroadcastMessage = {
    type: 'put',
    projectId,
    chapterId,
    backup,
  }
  ch.postMessage(message)
}

export function publishChapterBackupRemove(projectId: string, chapterId: string): void {
  const ch = getChannel()
  if (!ch) return
  const message: ChapterBackupBroadcastMessage = {
    type: 'remove',
    projectId,
    chapterId,
  }
  ch.postMessage(message)
}

/** Subscribe to cross-tab chapter backup changes. Returns an unsubscribe function. */
export function subscribeChapterBackupBroadcast(listener: BackupListener): () => void {
  getChannel()
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
